const PRIMARY = {
  main: "#27374D",
  contrastText: "#fff",
};
const SECONDARY = {
  main: "#eaa62b",
  contrastText: "#fff",
};

const palette = {
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  background: { default: "#eee", paper: "#fff", disabled: "#ddd" },
};

export default palette;
